import {
  LOAD_SATANNOTATIONS,
  LOAD_SATANNOTATIONS_SUCCESS,
  LOAD_SATANNOTATIONS_ERROR,
} from "../Types/satAnnotations.constants";

const INITIAL_STATE = {
  loading: false,
  satAnnotations: [],
  error: null,
};

export const SATAnnotationsListReducer = (
  state = INITIAL_STATE,
  action: any
) => {
  switch (action.type) {
    case LOAD_SATANNOTATIONS:
      return { ...state, loading: true, satAnnotations: [] };
    case LOAD_SATANNOTATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        satAnnotations: action.payload,
      };
    case LOAD_SATANNOTATIONS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
